import {
  type CommunityChannelData,
  type PrayerStreamDto,
} from '@ccm-innovation/member-center-bff-sdk-axios';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type ValueOf } from 'ts-essentials';

export const PrayerStreamUserStatus = {
  NOT_REGISTERED: 'NOT_REGISTERED',
  REGISTERED: 'REGISTERED',
  SELECT_COMMUNITY_GROUPS: 'SELECT_COMMUNITY_GROUPS',
} as const;

export type PrayerStreamUserStatus = ValueOf<typeof PrayerStreamUserStatus>;

export type StreamState = {
  communityChannelData: CommunityChannelData[] | null;
  connected: boolean;
  prayerStreamUserId: string | null;
  prayerStreamUserStatus: PrayerStreamUserStatus;
  prayerStreamUserToken: string | null;
};

const initialState: StreamState = {
  communityChannelData: null,
  connected: false,
  prayerStreamUserId: null,
  prayerStreamUserStatus: PrayerStreamUserStatus.NOT_REGISTERED,
  prayerStreamUserToken: null,
};

export const streamSlice = createSlice({
  initialState,
  name: 'stream',
  reducers: {
    clearStreamData: () => {
      return initialState;
    },
    setCommunityGroupList: (
      state,
      { payload }: PayloadAction<CommunityChannelData[] | null>,
    ) => {
      state.communityChannelData = payload;
    },
    setConnected: (state) => {
      state.connected = true;
    },
    setPrayerStreamUserDetails: (
      state,
      {
        payload,
      }: PayloadAction<
        Pick<PrayerStreamDto, 'getStreamUserId' | 'getStreamUserToken'>
      >,
    ) => {
      state.prayerStreamUserId = payload.getStreamUserId;
      state.prayerStreamUserToken = payload.getStreamUserToken;
    },
    setPrayerStreamUserStatus: (
      state,
      { payload }: PayloadAction<PrayerStreamUserStatus>,
    ) => {
      state.prayerStreamUserStatus = payload;
    },
  },
});
